var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4562 1.63623L10.2136 14.3642L8.79939 12.9499C7.2373 11.3878 7.2373 8.85518 8.7994 7.29308L14.4562 1.63623Z",
    fill: "#99FFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4562 1.63623L1.72852 5.87938L3.14273 7.29359C4.70483 8.85569 7.2373 8.85518 8.7994 7.29308L14.4562 1.63623Z",
    fill: "#99FFDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4562 1.63623L10.2136 14.3642L8.79939 12.9499C7.2373 11.3878 7.2373 8.85518 8.7994 7.29308M14.4562 1.63623L8.7994 7.29308M14.4562 1.63623L1.72852 5.87938L3.14273 7.29359C4.70483 8.85569 7.2373 8.85518 8.7994 7.29308",
    stroke: "#0A255C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconGreen);
export default __webpack_public_path__ + "static/media/ButtonIconGreen.216ed61f9845f584fa333a596e719b18.svg";
export { ForwardRef as ReactComponent };